import api from '../config/configApi';

export const servDeleteUser = async (idUser) => {
  let status = false;
  await api.delete(`/user/user/${idUser}`)
    .then((response) => {
      status = {
        type: 'success',
        mensagem: response.data.mensagem,
      };
    }).catch((err) => {
      if (err.response) {
        status = {
          type: 'error',
          mensagem: err.response.data.mensagem,
        };
      } else {
        status = {
          type: 'error',
          mensagem: 'Erro: Tente mais tarde!',
        };
      }
    });

  return status;
};
